<template>
  <div class="w-100 px-1 mb-3">
    <div class="mt-2">
      <p style="text-align: center; line-height: 2.3rem; font-size: 14pt">
        نعتذر انتهت فترة التسجيل على الإستمارة       </p>
      <div class="d-flex mt-4 justify-content-center">
        <b-button to="/" variant="primary" class="mx-auto">
          <div class="d-flex justify-content-center align-items-center">
            عودة للرئيسية
            <feather-icon class="ml-50" icon="ArrowLeftIcon" size="18" />
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver } from "vee-validate";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import ShamlPersonalInfo from "../../components/ShamlPersonalInfo";
import ShamlAttendanceInfo from "../../components/ShamlAttendanceInfo";

export default {
  components: {
    ShamlPersonalInfo,
    ShamlAttendanceInfo,
    FormWizard,
    TabContent,
    ValidationObserver,
  },
  data() {
    return {
      step: 1,
      shamlData: {
        gender: true,
        participating_fields: [],
        commitment: true,
        has_beneficial_ideas: true,
        is_disabled: false,
      },
    };
  },

  methods: {
    ...mapActions("Globals/ShamlForm", ["submitResponse"]),
    validatePersonalData() {
      return new Promise(async (resolve, reject) => {
        await this.$refs.personalDataValidation
          .validate()
          .then(async (success) => {
            if (success) {
              localStorage.setItem("shamlForm", JSON.stringify(this.shamlData));
              resolve(true);
            } else {
              reject(false);
            }
          });
      });
    },
    validateAttendanceData() {
      return new Promise(async (resolve, reject) => {
        await this.$refs.attendanceDataValidation
          .validate()
          .then(async (success) => {
            if (success) {
              if (this.shamlData.participating_fields.length === 0) {
                this.$toast.error("يجب اختيار محور واحد على الأقل", {
                  position: "bottom-center",
                  closeButton: "button",
                });
                reject(false);
              } else {
                var toSend = { ...this.personalData, ...this.shamlData };
                if (!toSend.is_disabled) delete toSend.disability_type;
                if (toSend.social_entity_type === "غير ذلك") {
                  toSend.social_entity_type = toSend.social_entity_type_other;
                }
                if (toSend.social_role === "غير ذلك") {
                  toSend.social_role = toSend.social_role_other;
                }
                delete toSend.social_entity_type_other;
                delete toSend.social_role_other;

                await this.submitResponse(toSend)
                  .then((res) => {
                    resolve(true);
                    localStorage.removeItem("shamlForm");
                    this.$router.push({ name: "shaml-form-submitted" });
                  })
                  .catch((err) => {
                    reject(false);
                  });
              }
            } else {
              reject(false);
            }
          });
      });
    },
  },

  mounted() {
    if (localStorage.getItem("shamlForm")) {
      this.shamlData = JSON.parse(localStorage.getItem("shamlForm"));
      this.$nextTick(() => {
        this.$refs.wizard.nextTab();
        this.$bvModal.msgBoxOk(" تم استرجاع البيانات من المسودة", {
          title: "تنويه",
          size: "sm",
          okVariant: "info",
          okTitle: "حسناً",
          hideHeaderClose: true,
          centered: true,
          okOnly: true,
        });
      });
    }
  },
};
</script>

<style>
.Vue-Toastification__close-button {
  color: rgb(27, 26, 26) !important;
}
</style>
